/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementCreateItemResponse } from './CarpsaleManagementCreateItemResponse';

export type CarpsaleManagementCreateItemResponseApiRespoonse = {
    data?: CarpsaleManagementCreateItemResponse;
    status?: CarpsaleManagementCreateItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementCreateItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

